/**
 * External Dependencies
 */
import 'jquery';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import Alpine from 'alpinejs'
const InfiniteScroll = require('infinite-scroll');
var $ = require('jquery');
var jQueryBridget = require('jquery-bridget');
var Isotope = require('isotope-layout');


var imagesLoaded = require('imagesloaded');

window.Alpine = Alpine

Alpine.start();

const inicio = document.getElementById('swiper-inicio');
if(inicio) {

  // init Swiper:
  const swiper = new Swiper('#swiper-inicio', {
    loop: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 80,
    speed: 600,
    navigation: {
      nextEl: '#next-publicaciones',
      prevEl: '#prev-publicaciones',
    },
    
    breakpoints: {
      640: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 40,
      },
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 0,
      },
      1280: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 0,
      },
      1920: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 0,
      },
    },
  });

}

const inicioTesis = document.getElementById('swiper-tesis');

if(inicioTesis){
  
  // init Swiper:
  const swiper = new Swiper('#swiper-tesis', {
    loop: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 80,
    speed: 600,
    autoHeight: false, // importante: desactivar autoHeight
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '#next-tesis',
      prevEl: '#prev-tesis',
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 40,
      },
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 0,
      },
      1280: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 0,
      },
      1920: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 0,
      },
    },
  });
  function equalizeSlides() {
  const slides = document.querySelectorAll('#swiper-tesis .swiper-slide article');
  let max = 0;
  slides.forEach(s => s.style.height = 'auto');
  slides.forEach(s => { max = Math.max(max, s.offsetHeight); });
  slides.forEach(s => s.style.height = max + 'px');
  swiper.update(); // actualizar Swiper tras cambiar alturas
  
}

// Llamadas iniciales y en resize
window.addEventListener('load', () => {
  // esperar imágenes cargadas
  const imgs = document.querySelectorAll('#swiper-tesis img');
  let loaded = 0;
  if (imgs.length === 0) { equalizeSlides(); return; }
  imgs.forEach(img => {
    if (img.complete) { if (++loaded === imgs.length) equalizeSlides(); }
    else img.addEventListener('load', () => { if (++loaded === imgs.length) equalizeSlides(); });
  });
});
window.addEventListener('resize', () => {
  // debounce simple
  clearTimeout(window._eqTimeout);
  window._eqTimeout = setTimeout(equalizeSlides, 150);
});
}

const grupo = document.getElementById('swiper-grupo');
if(grupo){
  // Swiper en pagina Grupo
  const swipe = new Swiper('.swiper', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 80,
    speed: 600,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}

const single = document.getElementById('swiper-single');
if (single) {
  // Swiper en la vista single
  const swipe = new Swiper('.swiper', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 80,
    speed: 600,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
  });
}

//Swipper en la vista Single DENTRO del contenido

const gallerySingle = document.querySelectorAll('.gallery');
const galleryItems = document.querySelectorAll('.gallery-item');


galleryItems.forEach(item => {
  item.classList.add('swiper-slide');
});

const wrapper = document.createElement('div');
const pagination = document.createElement('div');
const navPrev = document.createElement('div');
const navNext = document.createElement('div');

wrapper.classList.add('swiper-wrapper');
pagination.classList.add('swiper-pagination');
navPrev.classList.add('swiper-button-prev');
navNext.classList.add('swiper-button-next');

let g, new_g;

if(gallerySingle) {

gallerySingle.forEach(gallery => {

  gallery.classList.add('swiper'); //add class
  g = gallery.innerHTML; // get content
  new_g = `<div class="swiper-wrapper">` + g + `</div>`; //wrapper content with div

  gallery.innerHTML = new_g; //insert in DOM

  gallery.appendChild(pagination); //add divs for pagination and nav
  gallery.appendChild(navPrev);
  gallery.appendChild(navNext);

  //init gallery
  const swipe = new Swiper('.swiper', {
    loop: true,
    slidesPerView: 1,
    speed: 600,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
  });
});
}




//pagina produccion
function aplicarPaddingsDinamicosProduccion() {
    const container = document.querySelector('.grid-produccion');
    if (!container) return;
    
    // Obtener solo artículos visibles (filtrados)
    const articulosVisibles = Array.from(container.querySelectorAll('article'))
        .filter(article => {
            const estilo = window.getComputedStyle(article);
            return estilo.display !== 'none' && 
                   article.getAttribute('aria-hidden') !== 'true';
        });
    
    // Obtener el ancho de la ventana para responsive
    const windowWidth = window.innerWidth;
        
    const isDesktop = windowWidth >= 1024; // lg: breakpoint
    const isTablet = windowWidth <= 768; // md:breakpoint

    articulosVisibles.forEach((article, index) => {
        const position = index + 1; // 1-indexed
        const remainder = position % 3;
        const remainderTablet = position % 2;
        
        // ============================================
        // 1. APLICAR PADDINGS DINÁMICOS
        // ============================================
        // Resetear paddings
        article.style.paddingLeft = '';
        article.style.paddingRight = '';
        if(isDesktop) {
          // Aplicar nuevos paddings según posición visible
          if (remainder === 1) {
              // 1º, 4º, 7º... (3n + 1)
              article.style.paddingRight = '2.5rem';
              article.style.paddingLeft = '';
          } else if (remainder === 2) {
              // 2º, 5º, 8º... (3n + 2)
              article.style.paddingRight = '2.5rem';
              article.style.paddingLeft = '2.5rem';
          } else if (remainder === 0) {
              // 3º, 6º, 9º... (3n + 3)
              article.style.paddingRight = '';
              article.style.paddingLeft = '2.5rem';
          }
        }
        if (isTablet) {
          
          if (remainderTablet === 1) {
            article.style.paddingRight = '1rem'; // lg:pr-4
            article.style.paddingLeft = '0rem';
            
          } else if (remainderTablet === 0) {
            
                article.style.paddingRight = '0rem';
                article.style.paddingLeft = '1rem';
          }
        }
        // ============================================
        // 2. APLICAR CLASE .borde Y BORDES DINÁMICOS
        // ============================================
        // Añadir clase .borde si no la tiene
        if (!article.classList.contains('borde')) {
            article.classList.add('borde');
        }
        
        // Resetear bordes (eliminar estilos inline previos)
        article.style.borderRight = '';
        
        // Aplicar bordes según responsive y posición visible
        if (windowWidth <= 768) {
            // Móvil: sin borde derecho
                        // Tablet: borde en elementos impares
            if ((position % 2) !== 0) { // odd
                article.style.borderRight = '2px solid black';
            } else {
                article.style.borderRight = 'none';
            }
            //article.style.borderRight = 'none';
        } 
        else if (windowWidth > 768 ) {
            // Tablet: borde en elementos impares
            if ((position % 3) !== 0) { // odd
                article.style.borderRight = '2px solid black';
            } else {
                article.style.borderRight = 'none';
            }
        } 
        else if (windowWidth >= 1280) {
            // Desktop: borde en todos excepto cada 3 elementos
            if (remainder === 0) {
                // 3º, 6º, 9º... sin borde
                article.style.borderRight = '2px solid transparent';
            } else {
                article.style.borderRight = '2px solid black';
            }
        }
    });
    
    
}
//pagina publicaciones
function aplicarPaddingsDinamicosPublicaciones() {
    const container = document.querySelector('.container-grid-publicaciones');
    if (!container) return;
    
    // Obtener solo artículos visibles (filtrados)
    const articulosVisibles = Array.from(container.querySelectorAll('article'))
        .filter(article => {
            const estilo = window.getComputedStyle(article);
            return estilo.display !== 'none' && 
                   article.getAttribute('aria-hidden') !== 'true';
        });
    
    const windowWidth = window.innerWidth;
    const isDesktop = windowWidth >= 1024; // lg: breakpoint
    const isTablet = windowWidth <= 768; // md:breakpoint
    articulosVisibles.forEach((article, index) => {
        const position = index + 1;
        const remainder = position % 4;
        const remainderTablet = position % 2;
        
        // ===== RESETEAR PADDINGS =====
        article.style.paddingLeft = '';
        article.style.paddingRight = '';
        
        if (isDesktop) {
            // Desktop (lg): aplicar paddings según posición visible
            if (remainder === 1) {
                // 1º, 5º, 9º... (4n + 1)
                article.style.paddingRight = '20px'; // lg:pr-5
            } else if (remainder === 2) {
                // 2º, 6º, 10º... (4n + 2)
                article.style.paddingRight = '20px';
                article.style.paddingLeft = '20px';
            } else if (remainder === 3) {
                // 3º, 7º, 11º... (4n + 3)
                article.style.paddingRight = '20px';
                article.style.paddingLeft = '20px';
            } else if (remainder === 0) {
                // 4º, 8º, 12º... (4n + 4)
                article.style.paddingLeft = '20px';
            }
        }
        if (isTablet) {
          
          if (remainderTablet === 1) {
            article.style.paddingRight = '1rem'; // lg:pr-5
            article.style.paddingLeft = '2rem';
            
          } else if (remainderTablet === 0) {
            
                article.style.paddingRight = '1rem';
                article.style.paddingLeft = '1rem';
          }
        }
        // ===== BORDES (si aplica) =====
        // Resetear border
        article.style.borderRight = '';
        
        if (isDesktop) {
            if (remainder === 0) {
                // 4º, 8º, 12º... sin borde o borde transparente
                article.style.borderRight = '2px solid transparent';
            } else {
                article.style.borderRight = '2px solid black';
            }
        }
        if (isTablet) {
          console.log('tablet y vamos a ver los bordes')
          if (remainderTablet === 1) {
            console.log('tablet modulo:'+ remainderTablet === 1)
            article.style.borderRight = '2px solid black';
          } else {
            console.log('tablet modulo el otro')
            article.style.borderRight = '2px solid transparent';
          }
        }
    });
    
}
//las dos juntas
function aplicarPaddingsDinamicos() {
    // Detectar qué layout está presente
    const containerProduccion = document.querySelector('.grid-produccion');
    const containerPublicaciones = document.querySelector('.container-grid-publicaciones');
    
    if (containerProduccion) {
        aplicarPaddingsDinamicosProduccion();
    }
    
    if (containerPublicaciones) {
        aplicarPaddingsDinamicosPublicaciones();
    }
}

// Escuchar cambios de tamaño de ventana
window.addEventListener('resize', function() {
    setTimeout(aplicarPaddingsDinamicos, 100);
});
// Escuchar cambios de tamaño de ventana para reaplicar bordes
window.addEventListener('resize', function() {
    setTimeout(aplicarPaddingsDinamicos, 100);
});

// load more
let container = document.getElementById('container');

// make Isotope a jQuery plugin
jQueryBridget('isotope', Isotope, $);
imagesLoaded.makeJQueryPlugin($);
// now you can use $().isotope()

// Isotope sin layout
//https://codepen.io/desandro/pen/qBZoQp

// ============================================
// 1. LayoutMode 'none' - Estilo CodePen pero CORREGIDO para InfiniteScroll
// ============================================

// Guardar referencia al método original de Isotope
var originalArrange = Isotope.prototype.arrange;

// Layout mode 'none' sin romper la compatibilidad
Isotope.Item.prototype._create = function() {
  // assign id, used for original-order sorting
  this.id = this.layout.itemGUID++;
  // transition objects
  this._transn = {
    ingProperties: {},
    clean: {},
    onEnd: {}
  };
  this.sortData = {};
};

Isotope.Item.prototype.layoutPosition = function() {
  this.emitEvent( 'layout', [ this ] );
};

// Sobrescribir arrange pero MANTENIENDO la estructura de datos
Isotope.prototype.arrange = function( opts ) {
  // set any options pass
  this.option( opts );
  this._getIsInstant();
  // just filter - asegurar que filteredItems sea SIEMPRE un array
  var filtered = this._filter( this.items );
  this.filteredItems = Array.isArray(filtered) ? filtered : Array.from(filtered || []);
  // flag for initalized
  this._isLayoutInited = true;
  
  // Emitir evento para compatibilidad
  this.emitEvent('arrangeComplete', [ this ]);
};

// layout mode that does not position items
Isotope.LayoutMode.create('none');
var $grid = $('#container').isotope({
  itemSelector: 'article',
  layoutMode: 'none',
  transitionDuration: 0,
  // percentPosition: true,
  // layoutMode: 'fitRows',

});

// ============================================
// 2. Función para eliminar enlaces duplicados
// ============================================
function eliminarLinksHabitarDuplicados() {
  const articulos = document.querySelectorAll('article.content-flex-cat');
  
  articulos.forEach(articulo => {
    const enlaces = articulo.querySelectorAll('a.link-habitar');
    
    // Si hay más de un enlace, eliminar el primero
    if (enlaces.length > 1) {
      enlaces[0].remove();
      
    }
  });
}

$grid.imagesLoaded()
  .done(function () {        

  // init Isotope after all images have loaded
    //$grid.isotope('layout');
    
    $grid.isotope('arrange');
    eliminarLinksHabitarDuplicados();



});

jQueryBridget('infiniteScroll', InfiniteScroll, $);

// guardamos una instancia del isotope, para usar con el Infinte scroll en la opcion outlayer
let iso = $grid.data('isotope');

InfiniteScroll.imagesLoaded = imagesLoaded;

$grid.infiniteScroll({
  // options
  path: '.nav-previous a',
  append: '.post',
  history: false,
  button: '.view-more-button',
  // load pages on button click
  scrollThreshold: false,
  // disable loading on scroll
  status: '.page-load-status',
  outlayer: iso,
  prefill: false,

});

// ============================================
// 5. Manejar carga de nuevos elementos (CORREGIDO)
// ============================================
// Evento principal de InfiniteScroll
$grid.on('append.infiniteScroll', function(event, response, path, items) {
  console.log('Nuevos elementos cargados:', items.length);
  
  // Pequeño delay para asegurar DOM
  setTimeout(function() {
    // Eliminar duplicados
    eliminarLinksHabitarDuplicados();
    
    // Actualizar Isotope de forma segura
    $grid.isotope('reloadItems');

      // Recuperar el filtro actual desde localStorage
    var filtroActual = localStorage.getItem('filtroActual') || '*';
    $grid.isotope({ filter: filtroActual });

    // Forzar que filteredItems sea array antes de arrange
    // var isotopeInstance = $grid.data('isotope');
    // if (isotopeInstance && !Array.isArray(isotopeInstance.filteredItems)) {
    //   isotopeInstance.filteredItems = [];
    // }
    
    $grid.isotope('arrange');
  }, 100);
});

//filter items on button click
$('.filter-group').on('click', 'a', function () {
  var filterValue = $(this).attr('data-filter');
  $grid.isotope({ filter: filterValue });
 });

// Ejecutar después de cada filtro
if (typeof $grid !== 'undefined') {
    $grid.on('arrangeComplete', function() {
        setTimeout(aplicarPaddingsDinamicos, 50);
    });
    
    // También después de cargar nuevos elementos con InfiniteScroll
    $grid.on('append.infiniteScroll', function() {
        setTimeout(aplicarPaddingsDinamicos, 100);
    });
}

// Ejecutar inicialmente
document.addEventListener('DOMContentLoaded', function() {
    setTimeout(aplicarPaddingsDinamicos, 500);
});


const btnLista = document.getElementById('btn-lista');
const btnGrid = document.getElementById('btn-grid');
let listaView = document.getElementById('container-lista');
const btnMoreGrid = document.getElementById('more-grid');
const contGrid = document.getElementById('container-proyectos');
//pagina grupo alpinjs no fuciona en el server UPC
const btnMiembros = document.getElementById('btn-miembros');
const btnColab= document.getElementById('btn-colab');
const miembros = document.getElementById('miembros');
const colab = document.getElementById('colab');

function toogleView(e) {
  listaView.classList.toggle('hidden');

  contGrid.classList.toggle('hidden');

  btnMoreGrid.classList.toggle('hidden');
  // btnMoreList.classList.toggle('hidden');

  btnLista.classList.toggle('hidden');
  btnGrid.classList.toggle('hidden');
}
if(btnMiembros) {
  btnMiembros.addEventListener('click', function(){
    miembros.classList.toggle('hidden');

    this.lastElementChild.classList.toggle('girar');
    if(!colab.classList.contains('hidden')){

      btnColab.lastElementChild.classList.remove('girar');
      colab.classList.add('hidden');

    }
  })
}
if (btnColab) {
  btnColab.addEventListener('click', function () {
    colab.classList.toggle('hidden');
    this.lastElementChild.classList.toggle('girar');
    if (!miembros.classList.contains('hidden')) {
      btnMiembros.lastElementChild.classList.toggle('girar');
      miembros.classList.add('hidden');

    }
  })
}
if(btnLista) {
  btnLista.addEventListener('click', toogleView);
}

if(btnGrid) {
  btnGrid.addEventListener('click', toogleView);
}
if (contGrid) {
  //infinite scroll category proyectos
  var $contProy = new InfiniteScroll(contGrid, {
    // options
    path: '.nav-previous a',
    append: '.post',
    history: false,
    button: '.view-more-button',
    // load pages on button click
    scrollThreshold: false,
    //loader
    status: '.page-load-status',
  });
}

const misc = document.getElementById('container-misc');
if(misc){
  //infinite scroll category miscelanea
  var $contMisc = new InfiniteScroll(misc, {
    // options
    path: '.nav-previous a',
    append: '.post',
    history: false,
    button: '.view-more-button',
    // load pages on button click
    scrollThreshold: false,
    //loader
    status: '.page-load-status',
  });
}

const tesis = document.getElementById('container-tesis');
if(tesis){
  //infinite scroll category tesis
  var $contTesis = new InfiniteScroll(tesis, {
    // options
    path: '.nav-previous a',
    append: '.post',
    history: false,
    button: '.view-more-button',
    // load pages on button click
    scrollThreshold: false,
    //loader
    status: '.page-load-status',
  });
}

const docencia = document.getElementById('container-docencia');
if (docencia) {
  //infinite scroll category tesis

  var $contDocencia = new InfiniteScroll(docencia, {
    // options
    path: '.nav-previous a',
    append: '.post',
    history: false,
    button: '.view-more-button',
    // load pages on button click
    scrollThreshold: false,
    //loader
    status: '.page-load-status',
  });
}

//jquery menu
$(() => {
  $('.hamburger').on('click', function () {
    $(this).toggleClass('is-active');
    $('.nav-primary').toggleClass('-translate-x-full');
    $('body').toggleClass('overflow-hidden');
  });
  var link_tw = $('#menu-social li.twitter a').attr('href');
  var link_fb = $('#menu-social li.fb a').attr('href');
  var link_ln = $('#menu-social li.ln a').attr('href');

  $('#menu-social li.twitter').append('<a href="" class="link-icon tw"><i class="fab fa-twitter"></i></a>');
  $('.link-icon').attr('href', link_tw);

  $('#menu-social li.fb').append('<a href="" class="link-icon fb"><i class="fab fa-facebook-square"></i></a>');
  $('.link-icon-fb').attr('href', link_fb);

  $('#menu-social li.ln').append('<a href="" class="link-icon ln"><i class="fab fa-linkedin"></i></a>');
  $('.link-icon-ln').attr('href', link_ln);

  $('.nav-primary').wrapInner('<div class="nav-container"></div>')
});

//para el buscador
//var input = document.getElementById('buscador');
//var form = document.getElementById('form-habitar');
// var ancho = form.clientWidth - 20 + 'px';
//console.log(form)
// input.setAttribute('size', input.getAttribute('placeholder').length);

// input.setAttribute('size', ancho);

//single
//fix bug of plugins realted post, its render twice
const duplicate = document.getElementsByClassName('yarpp-related');

if (duplicate.length > 0) {
  duplicate[0].remove();
}
